import { DataTablePagination } from '@ui/components/data-table/data-table-pagination';
import { DataTable } from '@ui/components/data-table/data-table';
import { DataTableSearch, Typography } from '@ui/components';
import { FC } from 'react';

import { useCostCentersTable } from './use-cost-centers-table';

export const CostCentersTable: FC = () => {
  const { table, totalItems, tableSearchQuery, t, isLoading } = useCostCentersTable();
  return (
    <div className="bg-table-background rounded-lg overflow-auto">
      <div className="flex items-center px-4 py-3">
        <Typography variant="labelMediumMedium">
          {t('COST_CENTERS.TABLE_TOTAL_COST_CENTERS', { count: totalItems })}
        </Typography>

        <div className="ml-auto flex items-center gap-4">
          <DataTableSearch
            placeholder={t('COST_CENTERS.TABLE_SEARCH_PLACEHOLDER')}
            onChange={table.setGlobalFilter}
            value={tableSearchQuery}
          />

          <DataTablePagination
            pageIndex={table.getState().pagination.pageIndex}
            pageSize={table.getState().pagination.pageSize}
            prevPageDisabled={!table.getCanPreviousPage()}
            nextPageDisabled={!table.getCanNextPage()}
            prevPage={() => table.previousPage()}
            nextPage={() => table.nextPage()}
            totalRows={totalItems}
          />
        </div>
      </div>

      <DataTable
        noResultsComponent={
          <Typography variant="labelMediumBook">{t('COST_CENTERS.TABLE_NO_RESULTS')}</Typography>
        }
        columnsLength={table.getAllColumns().length}
        isLoading={isLoading}
        table={table}
      />
    </div>
  );
};
